<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Manage Avatar Widget Templates</h4>
  <div class="d-flex justify-content-end">
    <button type="button" aria-label="Close button" class="btn-close" aria-describedby="modal-title"
            (click)="modal.dismiss('cancel')"></button>
  </div>
</div>
<div class="modal-body">
  <div class="d-flex flex-wrap px-3">
    <div class="ms-auto">
      <button class="btn btn-primary btn-sm float-end" type="button" role="button" (click)="showAddEditTemplateModel(customizeTemplate, 'add')" >
        <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
        <span class="btn-wrapper--label">Add New</span>
      </button>
    </div>
  </div>
  <div class="p-3">
    <app-sb-table
      [rows]="widgetAvatarTemplates()"
      [totalRows]="totalRows()"
      [columns]="tableColumns"
      [options]="tableOptions"
      (stateChange)="onTableState($event)">
      <ng-template sbTableCell="name" let-template>{{ template.name}}</ng-template>
      <ng-template sbTableCell="image" let-template>
        <div class="image-variations">
          @for (variation of template.image_variations; track variation) {
          <div>
            <div class="thumbnail">
              <img class="img-fluid w-100" [src]="variation.url" alt="{{ variation.name }}">
            </div>
          </div>
          }
        </div>
      </ng-template>
      <ng-template sbTableActions let-template>
        <button type="button" class="btn-icon float-end" placement="bottom-right" container="body"
                [autoClose]="true" [ngbPopover]="popTemplate">
          <span class="fa fa-ellipsis-v"></span>
        </button>
        <ng-template #popTemplate>
          <a class="dropdown-item d-flex align-items-center pointer" (click)="showAddEditTemplateModel(customizeTemplate,'edit', template)">
            <i class="fa fa-pencil me-2" aria-hidden="true"></i>Edit
          </a>
          <a class="dropdown-item d-flex align-items-center pointer" (click)="deleteWidgetTemplate(template.id)">
            <i class="fa fa-trash me-2" aria-hidden="true"></i>Delete
          </a>
        </ng-template>
      </ng-template>
    </app-sb-table>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" type="button" (click)="modal.dismiss('cancel')">
    Close
  </button>
</div>

<ng-template #customizeTemplate let-modal>
  <div class="modal-header">
    <h4 class="modal-title text-capitalize">
      {{selectedAction}}
    </h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
            (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="form-wraper">
    <form (ngSubmit)="saveWidgetTemplateForm(modal)" [formGroup]="addWidgetAvatarTemplateForm" autocomplete="off">
      <div class="modal-body mb-5">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="floating-label">
              <input formControlName="name" placeholder=""
                     required class="floating-input"
                     type="text" autocomplete="off"/>
              <label>Name <span class="red">*</span></label>
              @if (submitted && f.name.errors) {
              <div class="bar error-brd">
                @if (f.name.errors.required) {
                <div class="invalid-text">Name is required</div>
                }
              </div>
              }
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-ms-12">
            <label class="label-text-css">Prompt <span class="red">*</span></label>
            <div class="mb-0">
              <div>Continue this prompt with your desired details. You don't need to add any facial details like gender, age, hair style, etc.</div>
              <textarea class="form-control border-start-0 border-top-0 border-end-0" formControlName="prompt" rows="10" style="padding-left: 10px;padding-right: 10px;" required placeholder="Ultra realistic, pilot, distinctive features of a pilot's uniform such as an emblematic pilot's cap, aviation headphones, and a flight suit"></textarea>
            </div>
            @if (submitted && f.prompt.errors) {
            <div class="bar error-brd">
              @if (f.prompt.errors.required) {
              <div class="invalid-text prompt-error-text">Prompt is required</div>
              }
            </div>
            }
          </div>
          <div class="col-12 text-center mt-3">
            <img class="img-fluid avatar-base-image" src="assets/images/avatars/ai-avatar-base.png" alt="Avatar Base Image">
            <button class="btn btn-primary btn-md" type="button" role="button" (click)="generateWidgetAvatarImages()">
              <span class="btn-wrapper--label">Generate</span>
            </button>
          </div>
          <div class="col-12">
            @if (submitted && f.prompt.value && f.image_variations.errors) {
            <div class="bar error-brd">
              @if (f.image_variations.errors.required) {
              <div class="invalid-text prompt-error-text">Please generate the image. Avatar Variation is required</div>
              }
            </div>
            }
          </div>
          <div class="mt-2 col-12">
            <div class="row justify-content-center">
              <div class="col-12">
                @if (selectedVariation()) {
                <div class="avatar-preview mb-3">
                  <img class="w-100 img-fluid" [src]="$safeNavigationMigration(selectedVariation()?.url)" alt="{{ selectedVariation()?.name }}">
                </div>
                }
              </div>
            </div>
            @if (imageVariations().length > 0) {
            <label>Variations</label>
            }
            @if (imageVariations().length > 0) {
            <div  class="image-variations">
              @for (variation of imageVariations(); track variation; let i = $index) {
              <div>
                <div class="thumbnail" [class.active]="variation.isActive" (click)="selectVariation(variation, i)">
                  <img class="img-fluid w-100" [src]="variation.url" alt="{{ variation.name }}">
                </div>
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-default me-2" type="button" (click)="modal.close()">Cancel</button>
        <button class="btn btn-primary me-2" type="submit">Save</button>
      </div>
    </form>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>
